module.exports = __webpack_public_path__ + "img/01-1-top-img.3158606f.png";